import { fetchApi } from '@/services/api-client';

export const PAGE_VIEWS_PATH = '/page-views';

export type PageViewContentType = 'news' | 'newsletter' | 'page';
export type PageViewPeriod = '7d' | '30d' | '90d';

export type PageViewTotal = {
  contentId: string;
  total: number;
};

export type PageViewDailyStat = {
  date: string;
  contentType: string;
  total: number;
};

export const pageViewsApi = {
  getTotals: (contentType?: PageViewContentType) => {
    const params = contentType ? `?contentType=${contentType}` : '';
    return fetchApi<PageViewTotal[]>(`${PAGE_VIEWS_PATH}/totals${params}`);
  },
  getStats: (period: PageViewPeriod = '30d', contentType?: PageViewContentType) => {
    const params = new URLSearchParams({ period });
    if (contentType) params.append('contentType', contentType);
    return fetchApi<PageViewDailyStat[]>(`${PAGE_VIEWS_PATH}/stats?${params}`);
  },
  getTop: (contentType: PageViewContentType, period: PageViewPeriod = '30d', limit = 10) => {
    const params = new URLSearchParams({ contentType, period, limit: String(limit) });
    return fetchApi<PageViewTotal[]>(`${PAGE_VIEWS_PATH}/top?${params}`);
  },
};
